/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useState, useRef } from 'react'
import { DatePicker, Space } from 'antd';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { useOnClickOutside } from '../../CommonMethods/OutsideClick';
import moment from 'moment'
import { useSearchParams } from 'react-router-dom';
import ErrorMessage from '../ErrorMessage';

export default function CustomDateRangePicker({ handleSetDate, DateRange, start, end, DateRangeError, customKey, setisDateOpen, datePickeropen, setDatePickeropen,
    SetDateRangeError, isFilter }) {

    const [open, setopen] = useState('');
    const ref = useRef(null)

    useOnClickOutside(ref, () => {
        setopen('');
        setisDateOpen(false);
        // setDatePickeropen(false)
    })

    const handleChange = (date) => {
        if (open === start) {
            handleSetDate(start, date);
        } else {
            handleSetDate(end, date)
        }
        setopen('')
        // setDatePickeropen(false)
    }

    const formattedTime = (date) => date !== '' && moment(date).format('MMM DD, YYYY')

    const error = () => DateRangeError[start] !== '' || DateRangeError[end] !== '';
    console.log(error())
    return (
        <div className={`relative z-10 ${customKey ? '' : ''}`}>
            <div className={`rounded ${!error() ? `border border-[#DDD]` : `border border-[#FC4523] text-[#FC4523]`}`} >
                <div className=' py-4 pl-[17px] pr-[28px] min-w-[346px] rounded'>
                    <div className='justify-between items-center flex rounded'>
                        <img src="/assets/images/calendar.svg" alt="calender" className='mr-4' />
                        <p data-testid="start-date"
                            className={`font-semibold text-[14px] ${open === end ? 'text-[#8E8E8E]' : open === start ? (!error() ? 'text-black' : 'text-[#FC4523]') : !error() ? 'text-black' : 'text-[#FC4523]'}`}
                            onClick={() => {
                                setopen(start);
                                isFilter && setDatePickeropen(true);
                                if (customKey) {
                                    setisDateOpen(!!open)
                                }
                            }}
                        >{DateRange[start] === '' ? 'MM/DD/YYYY' : formattedTime(DateRange[start])}</p>
                        <span className='px-2'>-</span>
                        <p data-testid="end-date"
                            className={`font-semibold  text-[14px] ${open === start ? 'text-[#8E8E8E]' : ''}  `}
                            onClick={() => {
                                setopen(end);
                                isFilter && setDatePickeropen(true);
                                if (customKey) {
                                    setisDateOpen(!!open)
                                }
                            }}
                        >{DateRange[end] === '' ? 'MM/DD/YYYY' : formattedTime(DateRange[end])}</p>
                    </div>
                </div>
            </div>
            {open !== '' && <div ref={ref}><Calendar className={`border-none shadowSupport rounded`} onChange={handleChange} value={[DateRange[start], DateRange[end]]} /></div>}
            {error() && <ErrorMessage message={DateRangeError[start] || DateRangeError[end]} error />}
        </div>
    )
}
